import { EnrollmentTypes } from '@api/ff-shared-services-api';

/* cspell: disable*/
const RegisterPharmacyActionTypes = {
	SAVE_REGISTER_INPUT_DATA: '@register/SAVE_REGISTER_INPUT_DATA',
	REMOVE_USER_DATA: '@register/REMOVE_USER_DATA',
	SAVE_USER_DATA: '@register/SAVE_USER_DATA',
	UPDATE_USER_DATA: '@register/UPDATE_USER_DATA',

	FETCH_PUBLIC_REGISTER_INIT_REQUEST: '@register/FETCH_PUBLIC_REGISTER_INIT_REQUEST',
	FETCH_CONFIGURATIONS_SUCCESS: '@register/FETCH_CONFIGURATIONS_SUCCESS',

	FETCH_ADD_REGISTER_DATA_SUCCESS: '@register/FETCH_ADD_REGISTER_DATA_SUCCESS',
	FETCH_UPDATE_REGISTER_DATA_REQUEST: '@register/FETCH_UPDATE_REGISTER_DATA_REQUEST',
	FETCH_UPDATE_REGISTER_DATA_SUCCESS: '@register/FETCH_UPDATE_REGISTER_DATA_SUCCESS',
	FETCH_UPDATE_REGISTER_DATA_ERROR: '@register/FETCH_UPDATE_REGISTER_DATA_ERROR',

	FETCH_SEND_FOR_APPROVAL_REQUEST: '@register/FETCH_SEND_FOR_APPROVAL_REQUEST',
	FETCH_SEND_FOR_APPROVAL_SUCCESS: '@register/FETCH_SEND_FOR_APPROVAL_SUCCESS',

	/* File upload actions */
	FETCH_UPLOAD_FILE_EXECUTION_REQUEST: '@register/FETCH_UPLOAD_FILE_EXECUTION_REQUEST',
	FETCH_UPLOAD_FILE_EXECUTION_SUCCESS: '@register/FETCH_UPLOAD_FILE_EXECUTION_SUCCESS',
	FETCH_UPLOAD_FILE_EXECUTION_ERROR: '@register/FETCH_UPLOAD_FILE_EXECUTION_ERROR',
	REMOVE_UPLOAD_FILE_EXECUTION: '@register/REMOVE_UPLOAD_FILE_EXECUTION',

	FETCH_DOWNLOAD_CONTRACT_FILE_REQUEST: '@register/FETCH_DOWNLOAD_CONTRACT_FILE_REQUEST',
	FETCH_DOWNLOAD_CONTRACT_FILE_SUCCESS: '@register/FETCH_DOWNLOAD_CONTRACT_FILE_SUCCESS',

	FETCH_DOWNLOAD_DOCUMENT_REQUEST: '@register/FETCH_DOWNLOAD_DOCUMENT_REQUEST',
	FETCH_DOWNLOAD_DOCUMENT_SUCCESS: '@register/FETCH_DOWNLOAD_DOCUMENT_SUCCESS',

	RESUME_REGISTER_REQUEST: '@register/RESUME_REGISTER_REQUEST',

	SAVE_REGISTER_ON_CANCEL: '@register/SAVE_REGISTER_ON_CANCEL',
};

export interface RegisterPharmacyState {
	externalId: string;
	configs: EnrollmentTypes.EnrollmentConfiguration;
	registerInputData: RegisterInputData;
}

export interface StepRegisterInputData {
	registerInputData?: RegisterInputData;
	stepIndex: number;
}

export interface ResumeInputData {
	externalId: string;
}

/* TODO: Add register pharmacy input data here */
export interface RegisterInputData {
	nipc?: string | null;
	entityName?: string | null;
	address?: string | null;
	postalCodePrefix?: string | null;
	postalCodeSuffix?: string | null;
	locality?: string | null;
	preferredContactName?: string | null;
	preferredContactEmail?: string | null;
	preferredContactPhonePrefix?: string | null;
	preferredContactPhoneNumber?: string | null;
	subscription?: SubscriptionTypes;
	typePermanentCertificate?: PermanentCertificateTypes;
	permanentCertificateCode?: string | null;
	//User data screen
	usersData?: UserData[] | null;
	//End of user data screen
	ibanNumber?: string | null;
	// registerInputFiles?: RegisterFileUploadType[] | null;

	proofInputFile?: RegisterFileUploadType;
	ibanInputFile?: RegisterFileUploadType;
	contractInputFile?: RegisterFileUploadType;

	////////ddddd

	// signaturesNumber?: number | null;

	// lastGeneratedContract?: RegisterFileUploadType;

	// messageToClient?: string;
	// messageToClientAttachments?: string[];

	// noApproveMessage?: string;
	// noApproveMessageAttachments?: string[];
}

export enum PermanentCertificateTypes {
	code = 'code',
	file = 'file',
}

export enum SubscriptionTypes {
	oneSubscription = 'oneSubscription',
	moreThanOneSubscription = 'moreThanOneSubscription',
}

export type UserData = {
	id?: string;
	idDocumentType: EnrollmentTypes.UserIdentificationDocumentType;
	idDocumentNumber: string;
	shortName: string;
	email: string;
	phonePrefix: string;
	phone: string;
	profileAccess: EnrollmentTypes.UserProfile;
	identificationDocument: RegisterFileUploadType;
	// userAccesses?: EnrollmentTypes.UserAccess[];
	// customAccesses: boolean;
};

export type RegisterFileUploadType = {
	id: string;
	fileName: string;
	inputType?: EnrollmentTypes.EnrollmentDocumentDocumentType;
	isDownloadable?: boolean;
};

export default RegisterPharmacyActionTypes;
